import { morphism, createSchema } from 'morphism';

const categoryListDataSchema = createSchema(
  {
    id: 'id',
    name: 'name',
    subCategories: 'subCategories'
  },
  { undefinedValues: { strip: true } }
);

export default {
  listCategory: createSchema(
    {
      docs: source => morphism(categoryListDataSchema, source?.data)
    },
    { undefinedValues: { strip: true } }
  )
};
